module.exports = __webpack_public_path__ + "eca99d61fadbddf72492568b4922ec1b.svg";